export default "__VITE_ASSET__DpGw8Dti__"